import { initInvoice } from "@telegram-apps/sdk";

export async function openInvoice(invoiceLink) {
  const invoice = initInvoice();
  return invoice.open(invoiceLink, "url");
}
